<template>
  <div>
    <b-button
      variant="primary"
      @click="showGoogleImage = true"
      class="btn w-100"
      >Show Google Image Search</b-button
    >
    <b-modal v-model="showGoogleImage" title="Search" size="xl"
      ><div class="gcse-search"></div
    ></b-modal>
  </div>
</template>

<script>
export default {
  name: "SearchImageComponent",
  props: {
    query: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showGoogleImage: false,
    };
  },
  mounted() {
    // Wait for the Google CSE script to initialize
    const script = document.createElement("script");
    script.src = "https://cse.google.com/cse.js?cx=115b9d43b3f1d43dc";
    script.async = true;
    script.onload = () => {
      this.performSearch(this.query);
    };
    document.head.appendChild(script);
  },
  methods: {
    performSearch(query) {
      // Parse the query if it contains GET parameters
      const urlParams = new URLSearchParams(query);
      const searchQuery = urlParams.get("gsc.q") || "";
      const tabValue = urlParams.get("gsc.tab") || "1";

      // Wait for GCS to initialize and then perform the search
      const interval = setInterval(() => {
        if (window.google && window.google.search && window.google.search.cse) {
          clearInterval(interval);
          window.google.search.cse.element.render({
            div: "gcse-search",
            tag: "search",
          });

          // Programmatically set the search query and tab if provided
          const searchBox = document.querySelector(".gsc-input");
          if (searchBox) {
            searchBox.value = searchQuery;
            const event = new Event("input", { bubbles: true });
            searchBox.dispatchEvent(event);
          }

          // Set the tab if applicable
          const tabInput = document.querySelector('input[name="gsc.tab"]');
          if (tabInput) {
            tabInput.value = tabValue;
          }

          // Trigger the search button
          const searchButton = document.querySelector(".gsc-search-button");
          if (searchButton) {
            searchButton.click();
          }
        }
      }, 100);
    },
  },
};
</script>

<style>
.gcse-search {
  margin: 10px 0;
}
</style>
